import React from "react";
import { Menu, MenuCategoria, MenuGrupo, MenuItem } from 'react-template';
import AuthorizationComponent from '../../auth/components/AuthorizationComponent';

export default class Nav extends React.Component {

    render() {
        return (
            <Menu>
                <MenuItem endereco="/admin" icon="home" name="Início" />
                <MenuCategoria name="Interno">
                    <MenuItem endereco="/admin/formularios-internos" icon="chrome_reader_mode" name="Preencher formulários" />
                    <MenuItem endereco="/admin/inscricoes-internas" icon="list" name="Inscrições" />
                </MenuCategoria>
                <AuthorizationComponent roles={['ADMINISTRADOR FORMS', 'GERENTE FORMS', 'ADMINISTRADOR GRU', 'GERENTE GRU']}>
                    <MenuCategoria name="Administrativo">
                        <AuthorizationComponent roles={['ADMINISTRADOR FORMS', 'GERENTE FORMS']}>
                            <MenuItem icon="subtitles" endereco="/admin/formulario" name="Formulários" />
                        </AuthorizationComponent>
                        <AuthorizationComponent roles={['ADMINISTRADOR GRU', 'GERENTE GRU']}>
                            <MenuGrupo icon="local_atm" titulo="GRU">
                                <MenuItem endereco="/admin/gru" name="Listar" />
                                <MenuItem endereco="/admin/gru/consultar" name="Consultar" />
                            </MenuGrupo>
                        </AuthorizationComponent>
                    </MenuCategoria>
                </AuthorizationComponent>
                <AuthorizationComponent roles={['GERENTE GRU']}>
                    <MenuCategoria name="Geração de GRUs">
                        <AuthorizationComponent roles={['ADMINISTRADOR GRU', 'GERENTE GRU']}>
                                <MenuItem icon="local_atm" endereco="/admin/fill" name="Preencher GRU" />
                        </AuthorizationComponent>
                    </MenuCategoria>
                </AuthorizationComponent>
                <MenuItem icon="exit_to_app" className="menu-logout" endereco="/logout" name="Sair" />
            </Menu>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/navegacao/Nav.js